import PillButton, {type PillButtonVariant} from '@/components/PillButton/PillButton';
import buttonActionService from '@/services/experienceScore/buttonActionService';
import type {ButtonModel} from '@/types/aem';

interface AemButtonProps {
    button?: ButtonModel;
    code?: string;
    variant?: PillButtonVariant;
    className?: string;
}

const AemButton = ({button, code, variant, className}: AemButtonProps) => {
    if (!button?.text) return null;

    return (
        <PillButton variant={variant} className={className} onClick={() => buttonActionService.run(button, code)}>
            {button.text}
        </PillButton>
    );
};

export default AemButton;
